import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { DiagnosisOptions } from '../interfaces/diagnosis-interface';

@Component({
    selector: 'app-diagnosis-menu-item',
    templateUrl: './diagnosis-menu-item.component.html',
    styleUrls: ['./diagnosis-menu-item.component.scss'],
    standalone: false
})
export class DiagnosisMenuItemComponent implements OnInit {

  @Input() diagnosisList: DiagnosisOptions[];
  @ViewChild('childMenu', {static: true}) public childMenu;
  @Output() selectDiagnosis = new EventEmitter<DiagnosisOptions>();
  
  constructor() { }

  ngOnInit(): void {
  }

  public emitSelectedDiagnosis(diagnosis: DiagnosisOptions): void {
    if (diagnosis.start !== '' && diagnosis.end !== '') {
      this.selectDiagnosis.emit(diagnosis);
    }
  }
}
